import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useState, useEffect } from 'react';
import { videoService } from '@/services/videoService';

export interface VideoForABTest {
  id: string;
  title: string;
  thumbnailUrl: string | null;
  duration: number;
  plays: number;
  views: number;
  inUse?: boolean;
  inUseText?: string;
}

export const useABTestVideos = (userId: string | null) => {
  useLanguage();
  const [videos, setVideos] = useState<VideoForABTest[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchVideos = async () => {
      if (!userId) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const fetchedVideos = await videoService.getDashboardVideos(userId);

        // Mapear para o formato esperado
        const mappedVideos: VideoForABTest[] = fetchedVideos.map((video) => ({
          id: video.id,
          title: video.title,
          thumbnailUrl: video.thumbnailUrl,
          duration: video.duration,
          plays: video.plays,
          views: video.views,
          inUse: video.is_testab === true || video.is_testab === 'true' || video.is_testab === 1,
          inUseText: video.is_testab ? 'Em teste A/B' : undefined,
        }));

        setVideos(mappedVideos);
      } catch (err: any) {
        console.error('Erro ao buscar vídeos:', err);
        setError(err?.message || translateInterfaceText("Erro ao carregar vídeos"));
        setVideos([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVideos();
  }, [userId]);

  return {
    videos,
    isLoading,
    error,
    refetch: () => {
      if (userId) {
        setIsLoading(true);
        videoService.getDashboardVideos(userId).then((fetchedVideos) => {
          const mappedVideos: VideoForABTest[] = fetchedVideos.map((video) => ({
            id: video.id,
            title: video.title,
            thumbnailUrl: video.thumbnailUrl,
            duration: video.duration,
            plays: video.plays,
            views: video.views,
            inUse: video.is_testab === true || video.is_testab === 'true' || video.is_testab === 1,
            inUseText: video.is_testab ? 'Em teste A/B' : undefined,
          }));
          setVideos(mappedVideos);
          setIsLoading(false);
        }).catch((err) => {
          setError(err?.message || translateInterfaceText("Erro ao carregar vídeos"));
          setIsLoading(false);
        });
      }
    },
  };
};
